<div class="decoration"></div>

<div class="content">
  <div class="top" *ngIf="!isDevMode">
    <app-language-selector></app-language-selector>
  </div>
  <div class="center">
    <div class="sytex-logo"><img src="assets/sytex-logo.svg" /></div>
    <router-outlet></router-outlet>
    <div class="footer">
      <div class="right">
        <div class="phrase" i18n="@@accelerate.field.operations">
          Accelerate Field Operations
        </div>
        <div class="hashtag">
          <span class="gradient-text-full">
            <span i18n="@@hashtag.efficiency">+Efficiency</span>
            <span i18n="@@hashtag.intelligence">+Intelligence</span>
            <span i18n="@@hashtag.quality">+Quality</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
